module.exports = __webpack_public_path__ + "static/media/tidal.a5edc75b.svg";